"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GetTestIds = exports.CloseModal = void 0;
var QuizModalMethods = _interopRequireWildcard(require("./QuizModal"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _QuizProvider = require("./QuizProvider");
var _classnames = _interopRequireDefault(require("classnames"));
var _function = require("../../utils/type-checks/function");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge"),
  CloseModal = (e, dispatch, onClose) => {
    const result = {
      dispatch: false,
      onClose: false
    };
    if ((0, _function.isFunction)(dispatch)) {
      dispatch({
        type: "toggleModal",
        value: false
      });
      result.dispatch = true;
    }
    if ((0, _function.isFunction)(onClose)) {
      onClose(e);
      result.onClose = true;
    }
    return result;
  },
  GetTestIds = testId => ({
    block: (0, _string.isStringOfLength)(testId) ? `${testId}__block` : undefined,
    component: (0, _string.isStringOfLength)(testId) ? testId : undefined
  });

/**
* Quiz Modal Window
*
* @visibleName Quiz Modal
* @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.GetTestIds = GetTestIds;
exports.CloseModal = CloseModal;
const QuizModal = props => {
  const {
      children,
      className,
      customTheme = {},
      hideIcon = false,
      onClose,
      icon,
      styles = {},
      testId
    } = props,
    quizTheme = _QuizProvider.Methods.useCustomTheme(),
    theme = merge.all([(0, _styles.useTheme)(), quizTheme, customTheme]),
    dispatch = _QuizProvider.Methods.useDispatch(),
    state = _QuizProvider.Methods.useState(),
    modalBox = (0, _react.useRef)(null),
    modalBoxStyles = merge({
      bgcolor: theme.quiz.modal.backgroundColor,
      borderColor: theme.quiz.modal.borderColor,
      borderStyle: "solid",
      borderWidth: "0.2rem",
      borderRadius: "0.5rem",
      boxShadow: 24,
      position: "absolute",
      left: "50%",
      overflowY: "auto",
      maxHeight: "calc(100% - 3.4rem)",
      p: 4,
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: {
        xs: "calc(100% - 2rem)",
        md: "86rem"
      },
      ".quiz__modal-close-button": {
        position: "absolute",
        right: 8,
        top: 8
      },
      ".quiz__modal-close-button-icon": {
        color: theme.quiz.modal.closeButtonColor
      },
      "&.quiz__modal-block--isCompleted": {
        width: {
          xs: "calc(100% - 2rem)",
          md: "67.9rem"
        }
      }
    }, styles),
    customClassNames = (0, _classnames.default)({
      "quiz__modal": true,
      [`${className}`]: className
    }),
    boxClassNames = (0, _classnames.default)({
      "quiz__modal-block": true,
      "quiz__modal-block--isCompleted": state.isCompleted
    }),
    testIdObj = QuizModalMethods.GetTestIds(testId),
    closeModal = e => QuizModalMethods.CloseModal(e, dispatch, onClose);
  (0, _react.useLayoutEffect)(() => {
    if (modalBox && modalBox.current && (0, _function.isFunction)(modalBox.current.scrollTo) && state.isModalOpen) {
      modalBox.current.scrollTo({
        behavior: "smooth",
        left: 0,
        top: 0
      });
    }
  }, [modalBox, state.isModalOpen, state.panelIndex]);
  return /*#__PURE__*/_react.default.createElement(_material.Modal, {
    "aria-label": "Quiz Modal",
    className: customClassNames,
    "data-testid": testIdObj.component,
    onClose: closeModal,
    open: state.isModalOpen
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: boxClassNames,
    "data-testid": testIdObj.block,
    ref: modalBox,
    sx: modalBoxStyles
  }, !hideIcon && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "Close Modal",
    className: "quiz__modal-close-button",
    onClick: closeModal
  }, icon && (0, _string.isStringOfLength)(icon) && /*#__PURE__*/_react.default.createElement("img", {
    alt: "Close Modal Window Icon",
    className: "quiz__modal-close-button-image",
    src: icon
  }), icon && !(0, _string.isStringOfLength)(icon) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "quiz__modal-close-button-image",
    component: "span"
  }, icon), !icon && /*#__PURE__*/_react.default.createElement(_Close.default, {
    alt: "Close Modal Window Icon",
    className: "quiz__modal-close-button-image"
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__modal-content"
  }, children)));
};

// Define propTypes;
QuizModal.propTypes = {
  /** Quiz modal child contents */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  /** Custom className */
  className: _propTypes.default.string,
  /** Custom theme object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Boolean to hide close icon block (Default Value: false) */
  hideIcon: _propTypes.default.bool,
  /** Custom close icon */
  icon: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Custom on modal close method */
  onClose: _propTypes.default.func,
  /** Custom styles object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = QuizModal;